module.exports = __webpack_public_path__ + "static/assets/499971232f47fdb5bf2f60ded2f0d119.png";